import { Box, makeStyles } from '@material-ui/core';
import { type CSSProperties } from '@material-ui/styles';
import React from 'react';

export const useColoredBoxStyles = makeStyles({
  boxRoot: {
    width: '100%',
    height: '100%',
    paddingTop: 3,
    paddingRight: 10,
    paddingBottom: 3,
    paddingLeft: 10,
    display: 'inline',
    verticalAlign: 'middle',
    borderWidth: 'thin',
    borderStyle: 'solid',
    borderRadius: 8,
    whiteSpace: 'nowrap',
  },
});

interface ColoredBoxProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  boxColor: string;
  dataTest?: string;
  boxStyle?: CSSProperties;
}
export const ColoredBox: React.FC<ColoredBoxProps> = ({
  boxColor,
  dataTest,
  children,
  boxStyle = {},
  style,
  ...rest
}) => {
  const classes = useColoredBoxStyles();
  return (
    <div
      style={{
        fontSize: 12,
        fontWeight: 700,
        color: boxColor,
        ...style,
      }}
      {...rest}
    >
      <Box
        display="flex"
        justifyContent="center"
        style={{
          borderColor: boxColor,
          ...boxStyle,
        }}
        className={classes.boxRoot}
        data-test={dataTest}
      >
        {children}
      </Box>
    </div>
  );
};
